import React from 'react';
import { FadeIn } from './FadeIn';
export function EmotionalHook() {
  return <section className="w-full py-24 px-6 bg-white relative" data-id="element-32">
      <div className="max-w-3xl mx-auto text-center" data-id="element-33">
        <FadeIn data-id="element-34">
          <p className="text-2xl md:text-3xl font-serif text-charcoal mb-8 leading-relaxed" data-id="element-35">
            Eran las 6:47 de la tarde.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-36">
          <p className="text-xl md:text-2xl text-charcoal-light mb-8 leading-relaxed" data-id="element-37">
            La cena estaba lista. La mesa estaba puesta.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-38">
          <p className="text-xl md:text-2xl text-charcoal-light mb-12 leading-relaxed" data-id="element-39">
            Y tú, parado frente a tu hijo, le pediste por tercera vez que
            apagara el iPad.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-40">
          <div className="bg-cream-dark/50 p-8 md:p-10 rounded-2xl mb-12 border-l-4 border-terracotta text-left" data-id="element-41">
            <p className="text-lg md:text-xl text-charcoal italic leading-relaxed" data-id="element-42">
              Lo que pasó después no necesita explicación. Los gritos. Las
              lágrimas. El portazo. El silencio frío que quedó en el aire.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-43">
          <p className="text-xl md:text-2xl text-charcoal-light mb-8 leading-relaxed" data-id="element-44">
            Y tú, sintiéndote culpable, cansado y preguntándote...
          </p>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-45">
          <p className="text-2xl md:text-3xl font-serif font-medium text-terracotta mb-16 leading-relaxed" data-id="element-46">
            "¿Soy mal padre? ¿Soy mala madre? ¿Por qué algo tan simple se
            convierte en una guerra?"
          </p>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-47">
          <div className="inline-block bg-terracotta text-white px-8 py-6 rounded-2xl shadow-lg transform -rotate-1" data-id="element-48">
            <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-49">
              No eres tú. No es tu hijo.
            </h3>
            <p className="text-xl md:text-2xl font-serif italic" data-id="element-50">
              Es la biología. Y tiene solución.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}